import React from 'react';
import {Link, Outlet} from 'react-router-dom';
import {AppHeader} from '../../ui/AppHeader';
import { LanguageSelector } from '../../features/shared/ui/LanguageSelector';
import { useTranslation } from 'react-i18next';
import Footer from '../../features/public/footer/Footer';
import { useSiteConfig } from '../providers/SiteConfigProvider';

export function PublicLayout() {
    const { t } = useTranslation();
    const { config } = useSiteConfig();

    return (
        <div className="appShell">
            <AppHeader
                left={
                    <div className="brandBlock">
                        <Link to="/" className="brandLogoLink">
                            <img 
                                src={config.logoNavbar}
                                alt="Logo Almassora" 
                                className="brandLogo"
                            />
                        </Link>
                        <div className="brandText">
                            <Link to="/" className="brand">
                                {t('publicLayout.title')}
                            </Link>
                        </div>
                    </div>
                }
                right={
                    <div className="appHeaderNav">
                        <Link to="/" className="navLink navPill active">
                            {t('publicLayout.projects')}
                        </Link>
                        <Link to="/administracion" className="navLink navPill">
                            {t('publicLayout.administration')}
                        </Link>
                        <LanguageSelector />
                    </div>
                }
            />
            <main className="appMain appMainPublic">
                <Outlet/>
            </main>
            <Footer />
        </div>
    );
}
